import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DecorativeSquares from "../../components/ui/DecorativeSquares";
import { FiPhoneCall } from "react-icons/fi";
import { GoSun, GoMoon } from "react-icons/go";
import { SlCalender } from "react-icons/sl";
import orderdish from "../../assets/images/svgs/cards/orders.svg";
import { CiLocationOn } from "react-icons/ci";
import PrimaryBtn from "../../components/button/PrimaryBtn";
import { useDispatch, useSelector } from "react-redux";
import CompleteOrderShimmer from "../../components/Preloader/CompleteOrderShimmer";
import { addOrupdatePlanOrder } from "../../redux/thunks/deiverAnorderThunk";
import NewPlanadded from "../../components/Modals/NewPlanadded";
import toast from "react-hot-toast";
import ConfirmChangeSubscription from "../../components/Modals/ConfirmChangeSubscription";
import { clearSubsOrderDraft } from "../../redux/slices/SubscriptionDraftSlice";

const SubscriptionplanDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { subscribeDraft } = useSelector((state) => state.subscribeDraft);
  const { isPlanLoading } = useSelector((state) => state.planSlice);
  const [planAdded, setPlanAdded] = useState(false);
  if (!subscribeDraft) {
    return <p className="text-center mt-8">No order details available</p>;
  }

  const toYYYYMMDD = (date) => {
    const d = new Date(date);
    return d.toISOString().split("T")[0];
  };

  const DAY_TO_NUMBER = {
    monday: "1",
    tuesday: "2",
    wednesday: "3",
    thursday: "4",
    friday: "5",
    saturday: "6",
    sunday: "7",
  };

  const WEEK_DAYS = [
    { id: 1, label: "M", name: "Monday" },
    { id: 2, label: "Tu", name: "Tuesday" },
    { id: 3, label: "W", name: "Wednesday" },
    { id: 4, label: "Th", name: "Thursday" },
    { id: 5, label: "F", name: "Friday" },
    { id: 6, label: "Sa", name: "Saturday" },
    { id: 7, label: "Su", name: "Sunday" },
  ];

  const formatExtraItemsForApi = (extras = []) => {
    return extras.map((item) => ({
      meal_extra_item_id: item.id, // 👈 IMPORTANT
      quantity: item.quantity,
    }));
  };

  const buildPayload = () => ({
    sp_customer_meal_plan_id: subscribeDraft.customer.cMealPlanId,
    service_provider_customer_id: Number(subscribeDraft.customer.id),
    meal_id: subscribeDraft.meal.meal_id,
    meal_plan_id: subscribeDraft.meal.planId,
    plan_type: subscribeDraft.plan.pType.toLowerCase(),
    meal_timing: subscribeDraft.plan.mTiming.toLowerCase(),
    start_date: toYYYYMMDD(subscribeDraft.plan.startingDate),
    meal_quantity: subscribeDraft.meal.mQty,
    delivery_preference: subscribeDraft.plan.deliType.toLowerCase(),
    ...(subscribeDraft.plan.deliType === "delivery" && {
      sp_customer_address_id: subscribeDraft.customer.spAddressId,
    }),

    total_amount: subscribeDraft.charges.subscriptCost,
    extra_items: formatExtraItemsForApi(subscribeDraft.meal.mExtra),

    ...(subscribeDraft.plan.pType === "monthly" && {
      delivery_days: subscribeDraft.plan.deliDays.map(String),
    }),
  });

  const handleStartSubscription = () => {
    setPlanAdded(true);
  };

  const handleConfirmSubscription = () => {
    const payload = buildPayload();
    console.log("Confirmed payload:", payload);

    dispatch(addOrupdatePlanOrder(payload))
      .unwrap()
      .then((res) => {
        if (res?.success === false) {
          toast.error(res.message || "Plan not added");
          return;
        }

        toast.success(res.message || "Plan added successfully");
        dispatch(clearSubsOrderDraft());

        setPlanAdded(false);

        setTimeout(() => {
          navigate("/customer");
        }, 1000);
      })
      .catch((err) => {
        toast.error(err || "Something went wrong");
      });
  };

  const mealTOtalAmnt = subscribeDraft.meal.mAmt * subscribeDraft.meal.mQty;
  // console.log("The mealTotal Amtis :", mealTOtalAmnt);

  return (
    <section className="relative min-h-screen ">
      <DecorativeSquares />

      {isPlanLoading ? (
        <CompleteOrderShimmer />
      ) : (
        <>
          {/* Center Card Wrapper */}
          <div className=" mt-8">
            <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl  shadow-sm">
              <div className="flex items-center gap-4 p-4">
                {/* Avatar */}
                <div className="flex items-center justify-center w-12 h-12 rounded-md bg-[#FFEFEB] text-[#FF6943] font-semibold">
                  {subscribeDraft.customer.intials}
                </div>

                {/* User Info */}
                <div className="flex flex-col">
                  <h2 className="text-base font-semibold text-gray-900">
                    {subscribeDraft.customer.name}
                  </h2>

                  <p className="mt-1 flex items-center gap-2 text-sm text-gray-600">
                    <FiPhoneCall />+{subscribeDraft.customer.cCode}{" "}
                    {subscribeDraft.customer.number}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Main details */}
          <div className="  mt-8">
            <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
              <div className="flex items-center gap-4">
                {/* Avatar */}
                <div className="flex items-center justify-center  rounded-md bg-[#FFEFEB] text-[#FF6943] font-semibold">
                  <img
                    src={subscribeDraft.meal.mImage}
                    alt={subscribeDraft.meal.mName}
                    className="object-cover w-12 h-12 rounded-md"
                  />
                </div>

                {/* User Info */}
                <div className="flex flex-col">
                  <h2 className="text-base font-semibold text-gray-900">
                    {subscribeDraft.meal.mName}
                  </h2>

                  <div className="flex justify-between ">
                    <p className="mt-1 flex items-center gap-2 text-sm   font-bold">
                      <img
                        src={orderdish}
                        alt="orderDish"
                        className="w-4 h-4"
                      />{" "}
                      {subscribeDraft.meal.mQty}
                    </p>
                    <p className="mt-1 flex items-center gap-2 text-sm text-[#FF6943] font-bold">
                      ${mealTOtalAmnt}
                    </p>
                  </div>
                </div>
              </div>

              <div className="border-b border-gray-200 mt-6 mb-2"></div>

              <div className="mt-4">
                {/* Order details */}
                <div className="relative -mx-4 sm:mx-0 overflow-x-auto lg:overflow-x-hidden mt-4">
                  <div className=" w-full md:min-w-[640px] rounded-lg border border-gray-200 bg-white">
                    <table className="w-full text-left text-sm sm:text-base text-gray-800">
                      <thead className="bg-gray-50">
                        {subscribeDraft.meal?.mExtra?.length > 0 && (
                          <tr>
                            <th
                              colSpan={2}
                              className="py-3 px-4 text-start text-base sm:text-lg font-semibold"
                            >
                              Extra items
                            </th>
                            <th
                              colSpan={2}
                              className="py-3 px-4 text-end text-base sm:text-lg font-semibold text-[#FF6943]"
                            >
                              ${subscribeDraft.charges?.extrasTotal}
                            </th>
                          </tr>
                        )}
                      </thead>

                      <tbody className="divide-y">
                        {subscribeDraft.meal?.mExtra?.length > 0 &&
                          subscribeDraft.meal?.mExtra?.map((item, i) => (
                            <tr key={i}>
                              <td colSpan={2} className="py-2 px-4">
                                <div className="flex items-center gap-2 whitespace-nowrap">
                                  <span className="inline-block w-2 h-2 rounded-full bg-[#FF6943]" />
                                  <span>{`${item.quantity} x ${item.name}`}</span>
                                </div>
                              </td>
                              <td className="py-2 px-4 text-end font-semibold whitespace-nowrap">
                                ${item.price}
                              </td>
                            </tr>
                          ))}

                        {/* Charges */}
                        <tr className="bg-gray-50">
                          <th colSpan={2} className="py-3 px-4 font-semibold">
                            Delivery charges
                          </th>
                          <th className="py-3 px-4 text-end font-semibold text-[#FF6943]">
                            ${subscribeDraft?.charges?.deliverCharges}
                          </th>
                        </tr>

                        {(() => {
                          const rawValue = Number(
                            subscribeDraft?.charges?.discount || 0,
                          );
                          const isDiscount = rawValue < 0;

                          return (
                            <tr>
                              <th
                                colSpan={2}
                                className="py-3 px-4 font-semibold"
                              >
                                {isDiscount ? "Discount" : "Other Charges"}
                              </th>

                              <th
                                className={`py-3 px-4 text-end font-semibold ${
                                  isDiscount ? "text-[#1CCB50]" : "text-red-500"
                                }`}
                              >
                                ${Math.abs(rawValue).toFixed(2)}
                              </th>
                            </tr>
                          );
                        })()}
                        <tr className="bg-orange-50">
                          <th
                            colSpan={2}
                            className="py-3 px-4 font-semibold text-[#FF6943]"
                          >
                            Total Order Amount
                          </th>
                          <th className="py-3 px-4 text-end font-semibold text-[#FF6943]">
                            ${subscribeDraft?.charges?.perOrderAmt}
                          </th>
                        </tr>
                        <tr className="bg-orange-50">
                          <th
                            colSpan={2}
                            className="py-3 px-4 font-semibold text-[#FF6943]"
                          >
                            Subscription cost ({subscribeDraft.meal.orderCounts}{" "}
                            Meals)
                          </th>
                          <th className="py-3 px-4 text-end font-semibold text-[#FF6943]">
                            ${subscribeDraft.charges.subscriptCost}
                          </th>
                        </tr>
                      </tbody>

                      <tfoot className="border-t bg-white">
                        <tr>
                          <th colSpan={2} className="py-3 px-4 font-medium">
                            Plan Type
                          </th>
                          <th
                            colSpan={2}
                            className="py-3 px-4 text-end font-semibold"
                          >
                            {subscribeDraft.plan.pType}
                          </th>
                        </tr>
                        <tr>
                          <th colSpan={2} className="py-3 px-4 font-medium">
                            Start Date
                          </th>
                          <th
                            colSpan={2}
                            className="py-3 px-4 text-end font-semibold"
                          >
                            {subscribeDraft.plan.startingDate}
                          </th>
                        </tr>
                        <tr>
                          <th colSpan={2} className="py-3 px-4 font-medium">
                            Meal Timing
                          </th>
                          <th
                            colSpan={2}
                            className="py-3 px-4 text-end font-semibold"
                          >
                            {subscribeDraft.plan.mTiming}
                          </th>
                        </tr>
                        {subscribeDraft.plan.pType === "monthly" && (
                          <tr>
                            <th colSpan={2} className="py-3 px-4 font-medium">
                              Deliver Days
                            </th>
                            <th
                              colSpan={2}
                              className="py-3 px-4 text-end font-semibold"
                            >
                              <div className="flex gap-2 justify-end mt-4 flex-wrap">
                                {WEEK_DAYS.map((day) => {
                                  const isSelected =
                                    subscribeDraft.plan.deliDays.includes(
                                      day.id,
                                    );

                                  return (
                                    <button
                                      key={day.id}
                                      type="button"
                                      className={`text-[10px] flex justify-center items-center rounded-md w-5 h-5 
                                        ${
                                          isSelected
                                            ? "bg-[#FF6943] text-white"
                                            : "bg-gray-200 text-[#FF6943]"
                                        }`}
                                    >
                                      {day.label}
                                    </button>
                                  );
                                })}
                              </div>
                            </th>
                          </tr>
                        )}
                        <tr>
                          <th colSpan={2} className="py-3 px-4 font-medium">
                            Delivery Type
                          </th>
                          <th
                            colSpan={2}
                            className="py-3 px-4 text-end font-semibold"
                          >
                            {subscribeDraft.plan.deliType}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              <div className="mt-4 flex justify-start gap-2">
                {subscribeDraft.customer?.address && (
                  <div className="mt-4 flex justify-start gap-2">
                    <CiLocationOn size={20} className="text-[#363636]" />
                    <p className="text-start text-[#363636] text-sm">
                      {subscribeDraft.customer.address}
                    </p>
                  </div>
                )}
              </div>
              <div className="flex justify-end  mt-4">
                <PrimaryBtn
                  btnName="Start Subscription"
                  clickEvent={handleStartSubscription}
                />
              </div>
            </div>
          </div>
        </>
      )}

      {planAdded && (
        <ConfirmChangeSubscription
          open={planAdded}
          onClose={() => setPlanAdded(false)}
          onConfirm={handleConfirmSubscription} // 👈 IMPORTANT
        />
      )}
    </section>
  );
};

export default SubscriptionplanDetails;
